import React from 'react';
import { GitBranch } from 'lucide-react';

const WorkflowsPage: React.FC = () => {
  return (
    <div className="space-y-6">
      <div className="text-center py-20">
        <GitBranch className="h-16 w-16 mx-auto text-gray-400 mb-4" />
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Agent Workflows</h2>
        <p className="text-gray-600">Workflows page coming soon...</p>
      </div>
    </div>
  );
};

export default WorkflowsPage;
